var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.domain)?_c('div',[(_vm.login == 1)?_c('DefaultLogin'):_c('LoginFloat')],1):_c('div')
}
var staticRenderFns = []

export { render, staticRenderFns }